import AllEvents from '../containers/events'

const EventsPage = () => {
  return (
    <div className='pb-8'>
      <AllEvents />
    </div>
  )
}

export default EventsPage
